import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import { ProjectRelatedVersionsService } from '@core/services/project-related-versions/project-related-versions.service';

import { ProjectRVErrors, ProjectRVStarting } from '@core/store/state/project-related-versions/project-related-versions.state';

import * as Objects from '@core/objects';

@Component({
    selector: 'core-versions-related-selector',
    templateUrl: './related-selector.component.html',
    styleUrls: ['./related-selector.component.scss']
})
export class VersionsRelatedSelectorComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly RELATED_ERROR = 2;


    @Input() project: Objects.Request;

    @Input() disabled: boolean;
    @Input()  selected: Array<Objects.AmsFile>;
    @Output() selectedChange = new EventEmitter<Array<Objects.AmsFile>>();
    public loadRelatedError: HttpErrorResponse | null = null;
    public loadFeedbacksError: HttpErrorResponse | null = null;

    public status: number = this.LOADING;
    public starting: ProjectRVStarting;
    public total: number = 0;
    public groups: Array<Objects.RelatedVersions> | null = null;

    // collect subscriptions to unsubscribe later
    private subs: Subscription = new Subscription();

    constructor( private projectRVSrv: ProjectRelatedVersionsService ) { }

    ngOnInit() {
        if (this.project){
            
            this.projectRVSrv.setProject(this.project)
        }

        // use service selectors
        this.subs.add(
            this.projectRVSrv.selectStarting().subscribe((ready_situation: ProjectRVStarting ) => {
                this.starting = ready_situation;
                this.init();
            })
        );

        this.subs.add(
            this.projectRVSrv.selectRelatedVersions().subscribe((related: Objects.RelatedVersions[]) => {
                this.groups = related.map(l => { return { ...l, labels: this.diffLabels(l.labels) } });
                this.groups.forEach(g => this.total = this.total + g.total);
                this.init();
            })
        );


        // Handle project errors
        this.subs.add(
            this.projectRVSrv.selectErrors().subscribe((errors: ProjectRVErrors) => {
                if (errors){
                    this.loadRelatedError = errors.load_related;
                    this.loadFeedbacksError = errors.load_feedbacks;
                    if (this.loadRelatedError )
                        this.status = this.RELATED_ERROR;            
                }
            })
        )


    
    }

    onChange(files: Array<Objects.AmsFile>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }


    private init() : void {
        if (this.starting && this.starting.related_ready && this.groups != null){
            this.status = this.DONE;
        }
    }

    private diffLabels(labels: Array<Objects.Label>): Array<Objects.Label> {
        return labels.filter(vl => !this.project.labels.some((rl: Objects.Label) => vl.id == rl.id));
    }

    ngOnDestroy(): void {
        this.projectRVSrv.clear();
        this.subs.unsubscribe();
    }


}